import React from "react"
import { Box, Button, CircularProgress, IconButton, Typography, styled } from "@mui/material"
import FileUploadIcon from '@mui/icons-material/FileUpload'
import UploadFileIcon from '@mui/icons-material/UploadFile'
import { InputStyle, LabelStyles, fileUpAreaMaskAreaStyle, fileUpAreaMaskStyle, fileUpAreaStyle, fileUpBoxStyle } from "./FileImporter.styles"
import { useTranslation } from "react-i18next"

const Input = styled('input')({
  opacity: 0,
  height: '100%',
  width: '100%',
  position: 'absolute',
  top: 0,
  cursor: 'pointer',
})

interface IFileImporterProps {
  loading: boolean
  handleFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}

export const FileImporter: React.FC<IFileImporterProps> = ({
  loading,
  handleFileChange,
}) => {
  const { t } = useTranslation()

  return (
    <Box sx={loading ? fileUpAreaMaskStyle : fileUpBoxStyle}>
      {loading && <Box sx={fileUpAreaMaskAreaStyle} />}
      <IconButton aria-label="upload picture" sx={{ width: '70px', height: '70px' }}>
        <UploadFileIcon sx={{ width: '50px', height: '50px', display: loading ? 'none' : '' }} />
        <CircularProgress color="inherit" sx={{ width: '50px', height: '50px', display: loading ? '' : 'none' }} />
      </IconButton>
      <Box sx={fileUpAreaStyle}>
        <Typography variant={'body1'} sx={LabelStyles}>
          {t('file_importer.drop_your_files_here_or')}&nbsp;
        </Typography>
        <Button size={'small'} variant="outlined" startIcon={<FileUploadIcon />}>
          {t('file_importer.upload')}
        </Button>
        <Input
          id="icon-button-file"
          type="file"
          onChange={handleFileChange}
        />
      </Box>
    </Box>
  )
}